<!--component html goes here -->
community patrol dashboard